// Persistent device token used for free-tier tracking
export const getDeviceToken = () => {
  let t = localStorage.getItem("ilmw_device_token");
  if (!t) {
    t = (crypto.randomUUID && crypto.randomUUID()) || `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("ilmw_device_token", t);
  }
  return t;
};
